
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Notification from '@/interfaces/Notification'
import { namespace } from 'vuex-class'
import DOMPurify from 'dompurify'

const Notifications = namespace('notifications')

@Component({})
export default class Snackbar extends Vue {
	@Prop({ type: Boolean, default: false })
	isPush!: boolean

	@Notifications.Action('remove')
	removeNotification

	@Notifications.State('notifications')
	notifications!: Array<Notification>

	visible: boolean = false

	get filteredNotifications() {
		return this.notifications.filter((n) => (this.isPush ? n.isPushMessage : !n.isPushMessage))
	}

	get sanitizedMessage() {
		return DOMPurify.sanitize(this.notification?.message ?? '')
	}

	get notification(): Notification | null {
		return this.filteredNotifications[0] || null
	}

	@Watch('notification')
	onNotificationChange(newVal: Notification | null, oldVal: Notification | null) {
		// Skip if notification didn't actually change (triggered by array mutation)
		if (oldVal && newVal && oldVal.id === newVal.id) {
			return
		}

		if (newVal) {
			// If transitioning from one notification to another
			if (oldVal) {
				// Ensure previous notification is hidden
				this.visible = false
				// Wait for animation to complete before showing next
				setTimeout(() => {
					this.showNotification(newVal)
				}, 350) // Slightly longer than animation duration
			} else {
				// First notification, show immediately
				this.showNotification(newVal)
			}
		}
	}

	showNotification(notification: Notification) {
		// Show notification
		this.visible = true

		// Set timeout for notification duration
		const timeout = notification.timeout || 6000
		setTimeout(() => {
			// Hide notification (start fade-out)
			this.visible = false

			// Wait for fade-out animation to complete
			setTimeout(() => {
				// Remove from store to show next notification
				this.$store.commit('notifications/remove', notification)
			}, 300) // Vuetify default transition duration
		}, timeout)
	}

	close() {
		if (this.notification) {
			this.removeNotification(this.notification)
		}
	}
}
